import { useState } from 'react';
import { Box, Button, Card, CardActions, CardContent, Chip, Drawer, FormControl, Menu, MenuItem, Select, Tooltip, Typography } from '@mui/material';
import opCardBg from '../../../../../src/assets/images/background/opCardBg.png';
import { ViewMoreIcon } from '../../../../assets/common-svg/CommonSvg';
import { getStatusConfig } from '../../../../utils/common';
import DynamicPreview from '../../../../lib/form-builder/components/features/DynamicPreview';
import { formatDateMoment } from '../../../../utils/utils';
import BsModal from '../BaseModal';
import AddTemplateForm from '../../../pages/TemplateManagement/addTemplateForm';
import { useDispatch, useSelector } from 'react-redux';
import { disableClonedModal, enableClonedModal, isClonedModal } from '../../../slices/formTemplate';

const OperationalCard = ({ data, handleViewDetail }) => {
  const [selectedVersions, setSelectedVersions] = useState({});
  const dispatch=useDispatch()
  const [cardId, setCardId] = useState(null)
  const [duplicateTemplate, setDuplicateTemplate] = useState({})
  const [anchorEl, setAnchorEl] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const addModal = useSelector(isClonedModal);
  const handleChange = (cardId, event) => {
    setSelectedVersions((prev) => ({
      ...prev,
      [cardId]: event.target.value,
    }));
  };
    const handleCloseModal = async () => {
      await dispatch(disableClonedModal());
      };
const open = Boolean(anchorEl);
  const handleOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    let cardData=data.find((item)=>item.id==id)
  setDuplicateTemplate({select_template:[{label:cardData.name, value:cardData.id}], 
    versions:cardData.versions.map((version)=>({label:`V.${version.version}`, value:version.version}))})

  };  

  const handleDuplicateEvent = () => {
    // setDuplicateTemplate(true)
    dispatch(enableClonedModal());
    setAnchorEl(null)
  }
  return (
    <div>
      <Box
        sx={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(min(300px, 100%), 1fr))',
          gap: 2,
        }}
      >
        {data.map((card) =>{
          const { text='Pending',color='#f8cebf', text_color='#e2612b'} = getStatusConfig(card.status);
          return (
          <Card
            key={card?.id}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              overflow: 'hidden',
              boxShadow: 'none',
            }}
            className='border rounded-2xl'
          >
            
            <div className="absolute top-3 right-3 z-10 flex items-center gap-x-1 cursor-pointer" onClick={(event)=>handleOpen(event, card?.id)}>
           <ViewMoreIcon/>
              {/* <BlockedIcon /> <span className='text-[#FF2023]'>{card.count}</span> */}
            </div>
            <CardContent
              sx={{
                position: 'relative',
                borderRadius: '12px',
                color: 'white',
                pb: 2,
                px: 2,
                backgroundImage: `linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), url(${opCardBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div className="flex gap-2 mb-2 mt-5">
                 <Tooltip
                    arrow
                    placement="top"
                    title={card?.name}
                  >
                    <Typography variant="h6" className="font-bold text-gray-800 truncate cursor-default">
                      {card?.name}
                    </Typography>
                  </Tooltip>
                  <Chip
                    label={text}
                    className='text-sm'
                    component="span"
                    size='small'
                    sx={{
                      fontSize: 12, backgroundColor: color,
                      '& .MuiChip-label': {
                        color: text_color
                      }
                    }}
                  />
              </div>
              <Box className="flex justify-between">
                <div>
                  <Typography variant="body2" className="text-gray-500">
                    Created Dated
                  </Typography>
                  <Typography variant="body2" className='text-gray-900'>{card.created_at?formatDateMoment(card.created_at):''}</Typography>
                </div>
                <div>
                  <Typography variant="body2" className="text-gray-500">
                    Last Updated
                  </Typography>
                  <Typography variant="body2" className='text-gray-900'>{card.updated_at? formatDateMoment(card.updated_at):''}</Typography>
                </div>
                  <div>
                    {card.version > 1 ? (
                      <>
                      <Typography variant="body2" className="text-gray-500">
                          Version
                        </Typography>
                        <FormControl variant="standard" sx={{ minWidth: '80' }}>
                          <Select
                            labelId={`version-select-label-${card.id}`}
                            id={`version-select-${card.id}`}
                            value={selectedVersions[card.id] || card.version}
                            onChange={(e) => handleChange(card.id, e)}
                            autoWidth
                            label="Version"
                          >
                            {Array.from({ length: card.version }, (_, i) => card.version - i).map((version) => (
                              <MenuItem key={version} value={version}>
                                V.{version}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </>
                    ) : (
                      <>
                        <Typography variant="body2" className="text-gray-500">
                          Version
                        </Typography>
                        <Typography variant="body2" className="text-gray-900">
                          V.{card.version}
                        </Typography>
                      </>
                    )}
                  </div>

              </Box>
            </CardContent>

            <CardActions className="flex justify-between mt-auto px-3 pb-2 pt-0 !bottom-0 left-0 w-full bg-white">
              <Button
                variant="contained"
                size='small'
                className="bg-blue-600 hover:bg-blue-700 text-white rounded-lg"
                onClick={()=>handleViewDetail(card?.id)}
              >
                View Details
              </Button>
              <Button
                variant="outlined"
                size='small'
                style={{
                  borderColor: '#A0A0A0',
                  color: '#A0A0A0',
                }}
                 onClick={()=>{setIsDrawerOpen(true); setCardId(card?.id)}}
              >
                Preview
              </Button>

            </CardActions>
          </Card>

          )
        })}
      </Box>

    {/* @info adding preview on more button */}
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={()=>setIsDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: '74%',
            minWidth: 600,
            maxWidth: 'calc(100% - 64px)',
          }
        }}
      >
        {isDrawerOpen && <DynamicPreview cardId={cardId} handleCloseDrawer={()=>setIsDrawerOpen(false)} />}
      </Drawer>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        PaperProps={{
          sx: {
            mt: 0.5,
            boxShadow: 3,
            borderRadius: 1.5,
            minWidth: 120,
          },
        }}
      >
        <MenuItem
          onClick={handleDuplicateEvent}
        >
          Duplicate
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null)
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null)
          }}
        >
          Delete
        </MenuItem>
      </Menu>

      <BsModal open={addModal} onClose={handleCloseModal} title="Create Form Template">
        <AddTemplateForm  tailoredDuplicate={duplicateTemplate}/>
      </BsModal>
    </div>
  );
};

export default OperationalCard;

